import * as types from 'modules/devices/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

const initialState = false;

const isSending = () => true;
const resetState = () => initialState;

export default createReducer<boolean>(initialState, {
  [types.SEND_BY_EMAIL]: isSending,
  [types.SEND_BY_EMAIL_SUCCESS]: resetState,
  [types.SEND_BY_EMAIL_FAILURE]: resetState,
  [types.OPEN_CREATE_DEVICE_MODAL]: resetState,
});
